<template>
    <v-form ref="etapeValidation" id="etapeValidation" v-model="$storeCandidature.etapeValidationValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <h3 class="text-md-left">
                {{$storeCandidature.langueFormulaire == 'en' ? 'Please check that all the information you have entered is correct' : 'Merci de valider que tous les renseignements que vous avez saisis sont exacts'}}
            </h3>

            <!-- Zone choix du programme -->
            <Comp_Valid_ChoixProgramme etape="1"></Comp_Valid_ChoixProgramme>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Identification -->
            <Comp_Valid_Identification etape="2"></Comp_Valid_Identification>
            <v-layout row wrap xs12 my-2></v-layout>          

            <!-- Zone Pièce à joindre-->
            <Comp_Valid_PiecesJointe etape="3"></Comp_Valid_PiecesJointe>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Payement-->
            <Comp_Valid_Paiement etape="4"></Comp_Valid_Paiement>

            <!--Consentement-->
            <v-layout row wrap xs12 my-2></v-layout>
            <v-card mt-2 pa-2>
                <h3 class="text-md-center font-weight-black" style="text-decoration: underline;">{{$storeCandidature.langueFormulaire == 'en' ? 'Step 5 : Data entered is correct' : 'Etape 5 : Données exactes'}}</h3>
                <v-switch class="pa-2"
                          :label="$storeCandidature.langueFormulaire == 'en' ? 'I certify that my data entered is correct. Any fraud or attempted fraud in the information provided, when submitting a request, may give rise to sanctions which may go as far as the cancellation of the registration and therefore the loss of any right or advantage obtained.'
                          : 'Je certifie que mes données saisies sont exactes. Toute fraude ou tentative de fraude dans les renseignements fournis, lors du dépôt de candidature, peut donner lieu à des sanctions allant jusqu\'a l\'invalidation de l\'inscrption et donc la perte de tout droit ou avantage obtenus'"
                          :readonly="!$storeCandidature.sasCandidature.Statut || $storeCandidature.sasCandidature.Statut.Id != $storeCandidature.configurationClient.StatutCandidatureEnCoursId"
                          v-model="$storeCandidature.sasCandidature.Identification.CertifiDonneeCorrect" :rules="[$rules.accepterCertification($storeCandidature.langueFormulaire)]"></v-switch>
            </v-card>
        </v-container>
    </v-form>
</template>

<script>
    import Comp_Valid_ChoixProgramme from "../components/CompValidationChoixProgramme";
    import Comp_Valid_Identification from "../components/CompValidationIdentification";
    import Comp_Valid_PiecesJointe from "../components/CompValidationPiecesJointes";
    import Comp_Valid_Paiement from "../components/CompValidationPaiement";

    export default {
        components: {
            Comp_Valid_ChoixProgramme,
            Comp_Valid_Identification,
            Comp_Valid_PiecesJointe,
            Comp_Valid_Paiement
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                testcheck: false,

                // Header parcours scolaires
                headerParcoursScolaires: [
                     { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Type of studies' : 'Type d\'études', value: 'typeEtudes' },
                ],
            }
        },

        methods: {
            // Formatage de la date
            formatDate(date) {
                if (date) { return this.$moment(String(date)).format('DD/MM/YYYY') }
                else { return '' }
            },
        }
    }
</script>

<style>
</style>